export enum EGender {
  Male = 1,
  Female = 2,
  Null = 3,
  Unknown = 4,
  Undecided = 5,
}

export const EGenderLabel = {
  [EGender.Male]: 'Laki-laki',
  [EGender.Female]: 'Perempuan',
  [EGender.Null]: 'Tidak Mengisi',
  [EGender.Unknown]: 'Tidak Diketahui',
  [EGender.Undecided]: 'Tidak Dapat Ditentukan',
};

export const EGenderEnglishLabel = {
  [EGender.Male]: 'Male',
  [EGender.Female]: 'Female',
  [EGender.Null]: 'Null',
  [EGender.Unknown]: 'Unknown',
  [EGender.Undecided]: 'Undecided',
};
